export default __webpack_public_path__ + "static/media/servicies-download.icon.408a1c13.svg";